import { useState } from "react";
import { Lock } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Dialog, DialogContent, DialogDescription, DialogFooter, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { Input } from "@/components/ui/input";

export function PasswordDialog({ open, onOpenChange, title, description, confirmLabel = "Onayla", danger, onConfirm }) {
  const [pw, setPw] = useState("");
  const [busy, setBusy] = useState(false);
  const close = (v) => { if (!v) setPw(""); onOpenChange(v); };
  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    const ok = await onConfirm(pw);
    setBusy(false);
    if (ok) close(false);
  };
  return (
    <Dialog open={open} onOpenChange={close}>
      <DialogContent data-testid="backup-password-dialog">
        <form onSubmit={submit}>
          <DialogHeader>
            <DialogTitle className="flex items-center gap-2"><Lock className="h-4 w-4" />{title}</DialogTitle>
            <DialogDescription>{description}</DialogDescription>
          </DialogHeader>
          <div className="py-4">
            <label className="text-[12px] text-slate-600">Parolanızı yeniden girin</label>
            <Input type="password" autoFocus value={pw} onChange={(e) => setPw(e.target.value)} data-testid="backup-password-input" />
          </div>
          <DialogFooter>
            <Button type="button" variant="outline" onClick={() => close(false)} data-testid="backup-password-cancel">Vazgeç</Button>
            <Button type="submit" variant={danger ? "destructive" : "default"} disabled={!pw || busy} data-testid="backup-password-confirm">{busy ? "İşleniyor…" : confirmLabel}</Button>
          </DialogFooter>
        </form>
      </DialogContent>
    </Dialog>
  );
}
